export type AuthRequestLease = {
  generation: number;
  signal: AbortSignal;
};

/**
 * Serializes identity-bound request chains. Starting a new chain aborts the
 * previous one, while the generation check protects state even when a client
 * ignores AbortSignal or resolves from an already-buffered response.
 */
export class AuthRequestGuard {
  private generation = 0;

  private controller: AbortController | null = null;

  begin(): AuthRequestLease {
    this.controller?.abort();
    this.generation += 1;
    this.controller = new AbortController();
    return {
      generation: this.generation,
      signal: this.controller.signal,
    };
  }

  invalidate(): void {
    this.controller?.abort();
    this.controller = null;
    this.generation += 1;
  }

  isCurrent(lease: AuthRequestLease): boolean {
    return lease.generation === this.generation && !lease.signal.aborted;
  }

  isCurrentForToken(
    lease: AuthRequestLease,
    expectedToken: string | null,
    currentToken: string | null,
  ): boolean {
    return this.isCurrent(lease) && expectedToken === currentToken;
  }
}
